import { useApp } from "../context/AppContext";
import { Link } from "react-router-dom";
import {
  Sun, BookOpen, Sparkles, Hash, CalendarDays, Star, Compass,
  HandHeart, Languages, Eye, HelpCircle, Gamepad2, Heart, Grid3X3,
  Moon, Coins, BookOpenCheck, Building2
} from "lucide-react";

const MODULES = (t) => [
  { to: "/prayer",   icon: Sun,         label: t.prayer },
  { to: "/quran",    icon: BookOpen,    label: t.quran },
  { to: "/names",    icon: Sparkles,    label: t.names },
  { to: "/dhikr",    icon: Hash,        label: t.dhikr },
  { to: "/hijri",    icon: CalendarDays,label: t.hijri },
  { to: "/prophets", icon: Star,        label: t.prophets },
  { to: "/qibla",    icon: Compass,     label: t.qibla },
  { to: "/duas",     icon: HandHeart,   label: t.duas },
  { to: "/arabic",   icon: Languages,   label: t.arabic },
  { to: "/tafsir",   icon: Eye,         label: t.tafsir },
  { to: "/quiz",     icon: HelpCircle,  label: t.quiz },
  { to: "/game",     icon: Gamepad2,    label: t.game },
  { to: "/values",   icon: Heart,       label: t.values },
  { to: "/sacred-nights", icon: Moon,           label: t.sacred_nights },
  { to: "/zakat",         icon: Coins,          label: t.zakat },
  { to: "/hifz",          icon: BookOpenCheck,  label: t.hifz },
  { to: "/mosques",       icon: Building2,      label: t.mosques }
];

export default function More() {
  const { t } = useApp();
  return (
    <div className="space-y-6 fade-in" data-testid="more-page">
      <header className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-2xl bg-nour-primary text-white flex items-center justify-center"><Grid3X3 className="w-6 h-6" /></div>
        <div>
          <h1 className="font-heading text-2xl font-bold">{t.more}</h1>
          <p className="text-sm text-nour-text2">{t.categories}</p>
        </div>
      </header>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        {MODULES(t).map(m => {
          const Icon = m.icon;
          return (
            <Link key={m.to} to={m.to} data-testid={`more-${m.to.replace(/^\//, "")}`} className="nour-card p-5 flex flex-col items-center text-center gap-2 hover:bg-emerald-50 transition">
              <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-emerald-50 to-emerald-100 flex items-center justify-center">
                <Icon className="w-6 h-6 text-nour-primary" />
              </div>
              <div className="font-heading font-semibold text-sm">{m.label}</div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
